import React, { useEffect, useState } from "react";
import { Routes, Route, useNavigate } from "react-router";
import XSifterAdminUserList from "./XSifterAdminUserList";
import { useAppSelector } from "../../store/hooks";

interface IXSifterAdminPageProps {
    onForceHeaderRemount: ()=>void;
}

const XSifterAdminPage: React.FC<IXSifterAdminPageProps> = (props: IXSifterAdminPageProps) => {
    const currentUser = useAppSelector((state) => state.app.currentUser);
    const navigate = useNavigate();

    useEffect(() => {
        if (currentUser?.role !== 'admin')
            navigate('/');
    }, [])

    return (
        <>
            <Routes>
                <Route path="*" element={<XSifterAdminUserList currentUser={currentUser} onForceHeaderRemount={props.onForceHeaderRemount} />} />
            </Routes>
        </>
    );
};

export default XSifterAdminPage;